import { Popover } from 'bootstrap'

/* function openOnHover(popover) {
  popover._element.addEventListener('mouseenter', function (e) {
    e.preventDefault()
    e.stopPropagation()
    popover.show()
  })
} */

function toggleOnClick(popover) {
  // eslint-disable-next-line no-underscore-dangle
  popover._element.addEventListener('click', (e) => {
    e.preventDefault()
    e.stopPropagation()
    popover.toggle()
  })
}

function closeOnClickOutside(popover) {
  document.addEventListener('click', (e) => {
    // eslint-disable-next-line no-underscore-dangle
    const isClickInsideElement = popover._element.contains(e.target)
    if (!isClickInsideElement) {
      popover.hide()
    }
  })
}

function setPopoverBehavior(popover) {
  // openOnHover(popover)
  toggleOnClick(popover)
  closeOnClickOutside(popover)
}

// Boostrap: Enable popovers everywhere
const popoverTriggerList = [].slice.call(
  document.querySelectorAll('[data-bs-toggle="popover"]')
)

const popovers = popoverTriggerList.map(
  (popoverTriggerEl) => new Popover(popoverTriggerEl)
)

popovers.forEach(setPopoverBehavior)
